import routes from './routes';
import * as VueRouter from 'vue-router';

const router = VueRouter.createRouter({
  // 4. Provide the history implementation to use. We are using the normal web history for simplicity here. (not hash)
  history: VueRouter.createWebHistory(),
  routes, // short for `routes: routes`
});
export default router;
